import http from '@/plugins/api'
import * as types from './types'
import { startLoading } from '@/plugins/loading'

const authUrl = window.config ? window.config.authUrl : ''

export default {
  clearToken({ commit, state }) {
    commit(types.RESET_LOGIN)
  },
  setToken({ commit }, token) {
    commit(types.SET_TOKEN, token)
  },
  rootFirmPreferences({ commit }, token) {
    commit(types.SET_ROOT_FIRM_PREFERENCES, token)
  },
  setPassthrough({ commit }, passthrough) {
    commit(types.SET_PASSTHROUGH, passthrough)
  },
  async getToken({ commit, getters, dispatch }, [user, pwd]) {
    const t = await startLoading(dispatch, 'getToken', () => http.post('getToken', { username: user, password: pwd }, {}, authUrl))
    if (Object.hasOwn(t.data, 'success')) {
      return t.data.reason
    } else {
      commit(types.SET_TOKEN, t.data)
      return 'success'
    }
  },
  async redeemTempToken({ commit, dispatch }, tempToken) {
    const t = await startLoading(dispatch, 'redeemTempToken', () =>
      http.post('user/redeemTempToken', JSON.stringify(tempToken), {
        headers: {
          'Content-Type': 'application/json'
        }
      })
    )
    if (Object.hasOwn(t.data, 'success')) {
      return t.data.reason
    } else {
      commit(types.SET_TOKEN, t.data)
      return 'success'
    }
  },
  async resetPassword({ commit, state, dispatch }, data) {
    const r = await startLoading(dispatch, 'resetPassword', () => http.post('user/resetPassword', data))
    return r.data
  },
  async getRootFirmPreferences({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getPreferences', () =>
      http.get('firm/firmPreference', {
        params: {
          firm: 1,
          category: 'General'
        }
      })
    )
    console.log('Got Root Firm Preferences: ', r.data)
    commit(types.SET_ROOT_FIRM_PREFERENCES, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js